export default class Mixin {
    constructor(...args) {
        this.args = args;
    }
    
    include($, content) {
        return this.style({$, content}, this.args);
    }

    style({$, content}, args) {
        return "";
    }

}